import React from 'react'
import BannerMainImageSection from '../../../bannerMainImageSection'
import BannerBrandImageSection from '../../../bannerBrandImageSection'
import * as E from '../homeElements'
import { Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { IProposalToBeReviewedStageProps } from '../stages/interfaces/IProposalToBeReviewedStageProps'

const ProposalToBeReviewedStage = (props: IProposalToBeReviewedStageProps) => {
  const {
    firstName,
    consultantFirstName,
    vehicleDescription,
    isSparta,
    estimateLink,
    reviewProposalLink,
  } = props

  return (
    <>
      <BannerMainImageSection>
        <E.WhiteHeading>OLY NOVATED LEASE</E.WhiteHeading>
        <h1 style={{color:'#fff'}}>Ready to jump into the driver&rsquo;s seat?</h1>
      </BannerMainImageSection>

      <BannerBrandImageSection id="maincontent">
        <E.ContainerBlock>
          <E.BannerButtonLinkParent>
            <Col sm={7}>
              <E.BannerButtonTitleRow>
                It's time to give your tick of approval {firstName}!
              </E.BannerButtonTitleRow>
              <Row>
                <div>
                  Hi {firstName}, {consultantFirstName}'s uploaded the final
                  details of your lease in your proposal. Take a moment to check
                  it over and give it your tick of approval.
                  {isSparta && ` Please accept it in a timely manner.`} Once you
                  do, we can start getting the{' '}
                  {vehicleDescription ? (
                    <span>{vehicleDescription}</span>
                  ) : (
                    <span>vehicle</span>
                  )}{' '}
                  ready for you.
                </div>
              </Row>
            </Col>
            <E.BannerButtonLinkChild>
              <Link to={reviewProposalLink} tabIndex={-1}>
                <E.BannerPrimaryButton extendInMob>
                  Review my proposal
                </E.BannerPrimaryButton>
              </Link>
              <br />
              <br />
              <Link to={estimateLink} tabIndex={-1}>
                <E.BannerPrimaryInverted extendInMob invertColor>
                  View my estimates again
                </E.BannerPrimaryInverted>
              </Link>
            </E.BannerButtonLinkChild>
          </E.BannerButtonLinkParent>
        </E.ContainerBlock>
      </BannerBrandImageSection>
    </>
  )
}

export default ProposalToBeReviewedStage
